export const DEFAULT_CAMPAIGN_CODE = "18LW99901O";
export const DEFAULT_LEAD_SOURCE_CODE = "67";
